import { type CountryCodes, latamLocale } from 'src/shared/utils/currency';
import { dataChangeResuestsApi } from 'src/old/api/dataChangeRequests/dataChangeRequest.api';
import { type ChangeFieldRequest, type EmployeeRequestedDataChange } from 'src/old/api/dataChangeRequests/types';
import { type DataChangeResuestsFilters } from 'src/modules/DataReview/types';
import { toastTypes } from 'src/shared/components/Toast/ToastOptions';
import { actionSuccess } from 'src/old/actions/utils';
import { type AppDispatch } from 'src/store';
import { addToast } from 'src/old/actions/toasts/toastsActions';

export const FETCH_DATA_CHANGE_REQUESTS = 'FETCH_DATA_CHANGE_REQUESTS';
export const PUT_DATA_CHANGE_REQUEST = 'PUT_DATA_CHANGE_REQUEST';

export const fetchDataChangeRequests =
  (locale: CountryCodes) =>
  (filters?: DataChangeResuestsFilters) =>
  async (dispatch: AppDispatch): Promise<boolean | undefined> => {
    if (locale && !latamLocale.includes(locale)) return;
    try {
      const response = await dataChangeResuestsApi.getDataChangeResuests(filters);
      dispatch(actionSuccess(FETCH_DATA_CHANGE_REQUESTS, response));

      return true;
    } catch (error: any) {
      console.error(error);
      return false;
    }
  };

export const putDataChangeRequest =
  (employeeRequest: EmployeeRequestedDataChange, updatedDataRequest: ChangeFieldRequest[]) =>
  async (dispatch: AppDispatch): Promise<boolean> => {
    try {
      await dataChangeResuestsApi.putDataChangeRequest(employeeRequest.personalId, updatedDataRequest);

      const withUpdatedDataRequestFields = {
        ...employeeRequest,
        dataConfirmation: {
          ...employeeRequest.dataConfirmation,
          changesRequested: updatedDataRequest
        }
      };
      dispatch(actionSuccess(PUT_DATA_CHANGE_REQUEST, withUpdatedDataRequestFields));
      dispatch(addToast(toastTypes.success));

      return true;
    } catch (error: any) {
      console.error(error);
      dispatch(addToast(toastTypes.error, error));
      return false;
    }
  };
